import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNavLangV2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 19,
	viewBox: "0 0 21 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M20.25 18L15 7.5L9.75 18",
			stroke: "#212121",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.25 15H18.75",
			stroke: "#212121",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.75 0.75V3",
			stroke: "#212121",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.75 3H12.75",
			stroke: "#212121",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.75 3C9.75 5.38695 8.80179 7.67613 7.11396 9.36396C5.42613 11.0518 3.13695 12 0.75 12",
			stroke: "#212121",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.26282 6C4.88331 7.75502 6.03272 9.27446 7.55272 10.349C9.07273 11.4236 10.8885 12.0004 12.75 12",
			stroke: "#212121",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgNavLangV2;
